import React from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getContactsActions,
  getUserRolesAction,
} from "../../actions/UserActions";
import {
  getAllTransactionsAction,
  getAllTasksAction,
  createTaskAction,
} from "../../actions/TransactionActions";
import { addPublicFormAction } from "../../actions/PublicFormsActions";
import { getVendorTransactionsAction } from "../../actions/VendorTransactionActions";
import {
  formatPhoneNumber,
  currencyFormat,
  toastMessage,
  cryptoTokenDecode,
  getContingencyData,
  convertTimeToMinutes,
  checkObjExists,
  toTitleCase,
} from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import { addDocAction, uploadDocumentAction } from "./../../actions/DocActions";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import StickyHeader from "./StickyHeader";
import { HelpOutline } from "@material-ui/icons";
import FormActionPrompt from "./FormActionPrompt";
import InputMask from "react-input-mask";
var _ = require("lodash");

class ClientSummary extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      contacts: [],
      transactions: [],
      transaction: {},
      events: [],
      fees: [],
      payments: [],
      contingencies: [],
      scheduleDate: "",
      appointmentDate: "",
      transactionId: "",
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      showPrompt: false,
      promptType: "",
      selectedTransClientEmail: "",
      errors: {},
      showLoader: false,
    };
    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  componentWillMount() {
    this.getAllTransactions();
  }

  handleTransactionSelection(e) {
    if (e) {
      this.setState({
        transaction: e,
        fees: !!e.fees ? e.fees : [],
        payments: !!e.payments ? e.payments : [],
        scheduleDate: e.scheduleDate,
        transactionId: e.id,
        contingencies: e.contingencies,
        selectedTransClientEmail: e.clientEmail,
        errors: {},
      });
    }

    this.getAllTasks(e.id);
  }

  clearTransactionSelection() {
    this.handleClosePrompt();
    this.setState({
      transaction: {},
      errors: {},
    });
  }

  handleShowPrompt(name) {
    this.setState({
      showPrompt: true,
      promptType: name,
    });
  }

  handleClosePrompt() {
    this.setState({
      showPrompt: false,
      promptType: "",
    });
  }

  getAllTransactions(id) {
    this.setState({
      showLoader: true,
    });
    if (
      this.state.userType === message.VENDOR &&
      this.state.currentRole === message.BUYERAGENT
    ) {
      this.props.getVendorTransactionsAction().then((vendorRes) => {
        this.setState({
          transactions: this.props.vendorTransactions.data || [],
          showLoader: false,
        });
      });
    } else {
      this.props.getAllTransactionsAction("INPROGRESS").then((res) => {
        this.setState({
          transactions: this.props.transactions.data || [],
          showLoader: false,
        });
      });
    }
  }

  getAllTasks(id) {
    this.props.getAllTasksAction(id).then((res) => {
      this.setState({
        events: this.props.tasks.data,
      });
    });
  }

  async exportFormToPDF() {
    this.setState({
      showLoader: true,
    });
    this.handleClosePrompt();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();

    let clientFullName =
      this.state.transaction.clientFirstName.trim() +
      (this.state.transaction.clientLastName
        ? " " + this.state.transaction.clientLastName.trim()
        : "");

    let fileName =
      "clientsummary" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1000 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.addDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .uploadDocumentAction(formData, transId, undefined, fileUploadName)
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf()
                .set(opt)
                .from(form)
                .save();
                this.setState({
                  showLoader: false,
                });
            });
        });
      } else {
        this.setState({
          showLoader: false,
        });
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  sendForm(transId) {
    this.setState({
      showLoader: true,
    });
    this.handleClosePrompt();

    let newEventStart = moment();
    let newEventEnd = moment();
    let newEventTime = convertTimeToMinutes(
      moment(newEventStart).get("hour") +
        ":" +
        moment(newEventStart).get("minutes")
    );

    let appoinmentDate = getContingencyData(
      this.state.contingencies,
      "First Appointment",
      "startDate"
    );

    let newPublicForm = {
      form: "intake",
      transactionId: transId,
      expiresOn: new Date(moment(appoinmentDate).subtract(5, "days")),
      auth: false,
    };

    this.props.addPublicFormAction(newPublicForm).then((newPubResIntake) => {});

    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        "Intake Form for @client_firstname @client_lastname",
      ],
      communicationTo: ["@client_email"],
      communicationType: "EMAIL",
      contingency: "Client",
      day: 0,
      description: [
        '<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="client_firstname">@client_firstname</a>!</p><p></p><p>The intake form for your appointment on @first_appointment_date is available at the link below. Just copy and paste it into your browser. Please complete and submit it as soon as possible. Thanks!</p><p></p><p>@intake_form_url</p>',
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Intake Form - Email",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          this.setState({
            showLoader: false,
          });
          toastMessage(code.SUCCESS, "Form sent");
        }
      });
    }

    newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [""],
      communicationTo: ["@client_phone"],
      communicationType: "TEXT",
      contingency: "Client",
      day: 0,
      description: [
        "Hey @client_firstname! We emailed you the intake form for your appointment on @first_appointment_date. Please complete and submit it as soon as possible. Thanks!",
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Intake Form - Text",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          this.setState({
            showLoader: false,
          });
        }
      });
    }
  }

  handleChange = (e, key) => {
    if (
      this.state.transaction &&
      Object.keys(this.state.transaction).length > 0
    ) {
      this.setState({
        transaction: {
          ...this.state.transaction,
          [key]: e.target.value,
        },
      });
    }
  };

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  getTypeDescription(invoice) {
    let typeDescription = "";

    typeDescription = invoice.invoiceType
      ? toTitleCase(invoice.invoiceType)
      : "";
    if (invoice.description) {
      if (invoice.description.length > 60) {
        typeDescription =
          typeDescription + " (" + invoice.description.slice(0, 60) + "...)";
      } else {
        typeDescription = typeDescription + " (" + invoice.description + ")";
      }
    }

    return typeDescription;
  }

  render() {
    // console.log(this.state.contingencies);

    let transactions = this.state.transactions;
    let transaction = this.state.transaction;
    let listedTransactions = [];

    for (let i = 0; i < transactions.length; i++) {
      let feesTotal = transactions[i].dsd.fees.reduce((acc, curr) => {
        if (curr.name !== "Brokerage Fee") {
          acc = acc + Number(curr.value);
        }
        return acc;
      }, 0);
      // new payment calculation using invoice details
      let paymentsTotal = 0;
      if (
        transactions[i].invoiceData &&
        transactions[i].invoiceData.length > 0
      ) {
        paymentsTotal = transactions[i].invoiceData.reduce((acc, curr) => {
          if (
            curr.invoiceType !== "DEPOSIT" &&
            curr.paymentStatus === "APPROVED"
          ) {
            acc = acc + Number(curr.amountCharged);
            if (curr.tipAmount) {
              acc = acc - Number(curr.tipAmount);
            }
            if (curr.serviceCharge) {
              acc = acc - Number(curr.serviceCharge);
            }
          }
          return acc;
        }, 0);
      }

      listedTransactions.push({
        label:
          transactions[i].shortName +
          " - " +
          transactions[i].dsd.buyer[0].firstname +
          (transactions[i].dsd.buyer[0].lastname
            ? " " + transactions[i].dsd.buyer[0].lastname
            : ""),
        id: transactions[i]._id,
        scheduleDate: moment(transactions[i].startDate).format("MM/DD/YYYY"),
        clientFirstName: transactions[i].dsd.buyer[0].firstname,
        clientLastName: transactions[i].dsd.buyer[0].lastname
          ? transactions[i].dsd.buyer[0].lastname
          : "",
        clientEmail: transactions[i].dsd.buyer[0].email,
        clientPhone: transactions[i].dsd.buyer[0].mobileNumber,
        artistName:
          transactions[i].dsd.listingAgents[0].firstname +
          " " +
          transactions[i].dsd.listingAgents[0].lastname,
        transactionType: transactions[i].transactionType,
        description: transactions[i].dsd.heldBy,
        totalCost: currencyFormat(transactions[i].dsd.agreedOpenPrice),
        // deposit:
        //   currencyFormat(transactions[i].dsd.emd) +
        //   " - " +
        //   moment(transactions[i].startDate).format("MM/DD/YYYY"),
        deposit: currencyFormat(transactions[i].dsd.emd),
        // paid: currencyFormat(
        //   transactions[i].dsd.otherEMD.reduce((acc, curr) => {
        //     acc = acc + Number(curr.value);
        //     return acc;
        //   }, Number(transactions[i].dsd.emd))
        // ),
        paid: currencyFormat(paymentsTotal),
        fees: transactions[i].dsd.fees.filter(
          (fee) => fee.name !== "Brokerage Fee"
        ),
        //payments: transactions[i].dsd.otherEMD,
        payments: transactions[i].invoiceData,

        // feesTotal: currencyFormat(
        //   // transactions[i].dsd.fees
        //   //   .filter((fee) => fee.name !== "Brokerage Fee")
        //   //   .map((fee) => _.sum(fee.value))
        //   transactions[i].dsd.fees.reduce((acc, curr) => {
        //     if (curr.name !== "Brokerage Fee") {
        //       acc = acc + Number(curr.value);
        //     }
        //     return acc;
        //   }, 0)
        // ),

        feesTotal: currencyFormat(feesTotal),
        // balance: currencyFormat(
        //   transactions[i].dsd.agreedOpenPrice +
        //     // _.sum(
        //     //   transactions[i].dsd.fees
        //     //     .filter((fee) => fee.name !== "Brokerage Fee")
        //     //     .map((fee) => fee.value)
        //     // )
        //     transactions[i].dsd.fees.reduce((acc, curr) => {
        //       if (curr.name !== "Brokerage Fee") {
        //         acc = acc + Number(curr.value);
        //       }
        //       return acc;
        //     }, 0) -
        //     transactions[i].dsd.emd -
        //     // _.sum(transactions[i].dsd.otherEMD.map((emd) => emd.value))
        //     transactions[i].dsd.otherEMD.reduce((acc, curr) => {
        //       acc = acc + Number(curr.value);
        //       return acc;
        //     }, 0)
        // ),
        balance: currencyFormat(
          Number(transactions[i].dsd.agreedOpenPrice) +
            Number(feesTotal) -
            Number(transactions[i].dsd.emd) -
            Number(paymentsTotal)
        ),
        status: transactions[i].status,
        shortName: transactions[i].shortName,
        description: transactions[i].dsd.heldBy,
        contingencies: transactions[i].contingencies,
      });
    }

    return (
      <div className="admin-steps admin-content-area">
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <StickyHeader
          listedTransactions={listedTransactions}
          transaction={this.state.transaction}
          handleTransactionSelection={this.handleTransactionSelection.bind(
            this
          )}
          clearTransactionSelection={this.clearTransactionSelection.bind(
            this
          )}
          handleShowPrompt={this.handleShowPrompt.bind(this)}
          selectedTransClientEmail={this.state.selectedTransClientEmail}
          formType="clientsummary"
          errorHandler={this.errorHandler.bind(this)}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-small font-600 mt-2 mb-3 pt-3">{`Summary Date: ${moment().format(
                      "MM/DD/YYYY"
                    )}`}</h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Client Summary
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>
                    :
                  </Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      this.handleChange(e, "clientFirstName")
                    }
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientFirstName
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    onChange={(e) => this.handleChange(e, "clientLastName")}
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientLastName
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Email:</Form.Label>
                  <Form.Control
                    type="email"
                    onChange={(e) => this.handleChange(e, "clientEmail")}
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientEmail
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Mobile Number:</Form.Label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    onChange={(e) => this.handleChange(e, "clientPhone")}
                    value={
                      checkObjExists(transaction)
                        ? formatPhoneNumber(transaction.clientPhone)
                        : ""
                    }
                    name="clientPhone"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                  {this.state.errors.clientPhone && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {this.state.errors.clientPhone}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            {/* <Row>
              <Col xs={12} sm={2}>
                <Form.Group>
                  <Form.Label>Client Name<span className="text-danger"> *</span>:</Form.Label>
                  <Form.Control
                    type="text"
                    name="clientName"
                    id="clientName"
                    onChange={(e) => this.handleChange(e, "clientName")}
                    value={
                      checkObjExists(transaction) ? transaction.clientName : ""
                    }
                    isInvalid={!!this.state.errors.clientName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={2}>
                <Form.Group>
                  <Form.Label>Client Email:</Form.Label>
                  <Form.Control
                    value={
                      checkObjExists(transaction) ? transaction.clientEmail : ""
                    }
                    type="email"
                    name="clientEmail"
                    id="clientEmail"
                    onChange={(e) => this.handleChange(e, "clientEmail")}
                    isInvalid={!!this.state.errors.clientEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={2}>
                <Form.Group>
                  <Form.Label>Client Mobile Number:</Form.Label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    onChange={(e) => this.handleChange(e, "clientPhone")}
                    value={
                      checkObjExists(transaction)
                        ? formatPhoneNumber(transaction.clientPhone)
                        : ""
                    }
                    name="clientPhone"
                    id="clientPhone"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                  {this.state.errors.clientPhone && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {this.state.errors.clientPhone}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row> */}

            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Artwork Information
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={2}>
                <Form.Group>
                  <Form.Label>Artist Name:</Form.Label>
                  <Form.Control
                    value={
                      checkObjExists(transaction)
                        ? transaction.artistName
                        : ""
                    }
                    type="text"
                    name="artistName"
                    id="artistName"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={2}>
                <Form.Group>
                  <Form.Label>Artwork Type:</Form.Label>
                  <Form.Control
                    value={
                      checkObjExists(transaction)
                        ? transaction.transactionType
                        : ""
                    }
                    type="text"
                    name="artworkType"
                    id="artworkType"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={2}>
                <Form.Group>
                  <Form.Label>Artwork Description:</Form.Label>
                  <Form.Control
                    value={
                      checkObjExists(transaction)
                        ? transaction.description
                        : ""
                    }
                    type="text"
                    name="artworkDescription"
                    id="artworkDescription"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={2}>
                <h4 className="title-small font-600 mt-2 mb-3 pt-3">
                  Total Cost:{" "}
                  {checkObjExists(transaction) ? transaction.totalCost : ""}
                </h4>
                <h4 className="title-small font-600 mt-2 mb-3 pt-3">
                  Deposit:{" "}
                  {checkObjExists(transaction) ? transaction.deposit : ""}
                </h4>
              </Col>
              <Col xs={12} sm={2}>
                <h4 className="title-small font-600 mt-2 mb-3 pt-3">
                  Total Fees:{" "}
                  {checkObjExists(transaction) ? transaction.feesTotal : ""}
                </h4>
                <h4 className="title-small font-600 mt-2 mb-3 pt-3">
                  Total Paid:{" "}
                  {checkObjExists(transaction) ? transaction.paid : ""}
                </h4>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-small font-600 mt-2 mb-3 pt-3">
                      Fees Breakdown
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <table class="table mr-5 ml-3">
                <thead>
                  <tr>
                    <th class="scope">Name/Date</th>
                    <th class="scope">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {checkObjExists(transaction)
                    ? this.state.fees.map((fee) => (
                        <tr>
                          <td>{fee.name}</td>
                          <td>{currencyFormat(fee.value)}</td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-small font-600 mt-2 mb-3 pt-3">
                      Payments Breakdown
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <table class="table mr-5 ml-3">
                <thead>
                  <tr>
                    <th class="scope">Description</th>
                    <th class="scope">Payment Mode</th>
                    <th class="scope">Requested Amount</th>
                    <th class="scope" title="Convenience Fee">
                      Conv Fee
                    </th>
                    <th class="scope">Tip Amount</th>
                    <th class="scope">Charged Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {checkObjExists(transaction)
                    ? transaction.payments.map((invoice) => (
                        <tr>
                          <td>{this.getTypeDescription(invoice)}</td>
                          <td>
                            {invoice.paymentMethod
                              ? toTitleCase(invoice.paymentMethod)
                              : ""}
                          </td>
                          <td>
                            {invoice.amount
                              ? currencyFormat(invoice.amount)
                              : "$0.00"}
                          </td>
                          <td>
                            {invoice.serviceCharge
                              ? currencyFormat(invoice.serviceCharge)
                              : "$0.00"}
                          </td>
                          <td>
                            {invoice.tipAmount
                              ? currencyFormat(invoice.tipAmount)
                              : "$0.00"}
                          </td>
                          <td>
                            {invoice.amountCharged
                              ? currencyFormat(invoice.amountCharged)
                              : "$0.00"}
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                  Balance Due:{" "}
                  {
                    <h4 className="title-medium font-400">
                      {checkObjExists(transaction)
                        ? transaction.balance
                        : null}
                    </h4>
                  }
                </h4>
              </Col>
            </Row>
          </Form>
        </div>

        <FormActionPrompt
          transaction={this.state.transaction}
          promptType={this.state.promptType}
          showPrompt={this.state.showPrompt}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          sendForm={this.sendForm.bind(this)}
          handleClosePrompt={this.handleClosePrompt.bind(this)}
          clearTransactionSelection={this.clearTransactionSelection.bind(
            this
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    transactions: state.reducer.transactions,
    vendorTransactions: state.reducer.vendorTransactions,
    tasks: state.reducer.tasks,
  };
};

export default connect(
  mapStateToProps,
  {
    addDocAction,
    uploadDocumentAction,
    getAllTransactionsAction,
    getVendorTransactionsAction,
    getContactsActions,
    getUserRolesAction,
    getAllTasksAction,
    createTaskAction,
    addPublicFormAction,
  }
)(ClientSummary);
